import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import IJob from '../../../app/_interfaces/IJob';

@Injectable({
  providedIn: 'root',
})
export class JobsService {
  constructor(private http: HttpClient) {}

  getAll(customers_id: number) {
    return this.http.get<IJob[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/jobs`
    );
  }

  get(customers_id: number, id: number) {
    return this.http.get<IJob[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/jobs/${id}`
    );
  }

  create(customers_id: number, job: IJob) {
    return this.http.post(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/jobs`,
      job
    );
  }

  update(customers_id: number, id: number, job: IJob) {
    const payload: IJob = {
      ...job,
      id: undefined,
    };

    return this.http.patch(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/jobs/${id}`,
      payload
    );
  }

  delete(customers_id: number, job: IJob) {
    return this.http.delete(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/jobs/${job.id}`
    );
  }

  getJobs(customers_id: number) {
    return this.http.get<IJob[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/jobs`,
      {}
    );
  }
}
